import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export const HelmetComponent: React.FC = (): JSX.Element => {
  const { i18n, t } = useTranslation();

  const scriptAttributes1 = {
    src: '//cdn.iubenda.com/cs/gpp/stub.js',
    type: 'text/javascript',
  };

  const scriptAttributes2 = {
    src: '//cdn.iubenda.com/cs/iubenda_cs.js',
    type: 'text/javascript',
    charset: 'utf8',
    async: true,
  };

  return (
    <Helmet>
      <script type="text/javascript">
        {`var _iub = _iub || [];
          _iub.csConfiguration = {
            askConsentAtCookiePolicyUpdate: true,
            countryDetection: true,
            enableLgpd: true,
            enableUspr: true,
            floatingPreferencesButtonCaptionColor: "#D61B01",
            floatingPreferencesButtonColor: "#FFFFFF",
            floatingPreferencesButtonDisplay: "anchored-center-right",
            invalidateConsentWithoutLog: true,
            lang: "${i18n.resolvedLanguage}",
            lgpdAppliesGlobally: false,
            perPurposeConsent: true,
            siteId: 2959206,
            whitelabel: false,
            cookiePolicyId: ${t('COOKIE_BANNER.COOKIE_ID')},
            cookiePolicyUrl: "https://auction.mbeglobal.com/files/legal/cookie_policy_${
              i18n.resolvedLanguage
            }.pdf",
            privacyPolicyUrl: "https://auction.mbeglobal.com/files/legal/privacy_information_${
              i18n.resolvedLanguage
            }.pdf",
            privacyPolicyNoticeAtCollectionUrl: "https://auction.mbeglobal.com/files/legal/legal_notes_${
              i18n.resolvedLanguage
            }.pdf",
            banner: {
              acceptButtonColor: "#D61B01",
              acceptButtonDisplay: true,
              backgroundColor: "#E5E3DF",
              backgroundOverlay: true,
              brandBackgroundColor: "#E5E3DF",
              brandTextColor: "#000000",
              closeButtonRejects: true,
              customizeButtonDisplay: true,
              explicitWithdrawal: true,
              fontSizeCloseButton: "26px",
              listPurposes: true,
              logo: "https://www.mbe.it/img/mbe-logo-footer.png",
              linksColor: "#D61B01",
              position: "float-bottom-center",
              rejectButtonColor: "#D61B01",
              rejectButtonDisplay: true,
              textColor: "#000000",
              acceptButtonCaption: "${t('COOKIE_BANNER.ACCEPT_ALL').toUpperCase()}",
              rejectButtonCaption: "${t('COOKIE_BANNER.ACCEPT_ONLY_NECESSARY').toUpperCase()}",
             },
            };`}
      </script>
      <script {...scriptAttributes1} />
      <script {...scriptAttributes2} />
    </Helmet>
  );
};
